<template>
    <button type="button"
        class="h-8 rounded border-2 border-green-500 bg-gray-900/75 px-5 text-green-500
            backdrop-blur-sm hover:bg-green-900 focus:bg-green-900 focus:outline-none">
        <slot></slot>
    </button>
</template>
